import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { questions } from '../data/faq';
export function FAQ() {
  const [open, setOpen] = useState(0);
  return <section className="bg-blue-950 py-20" aria-labelledby="faq-title" data-id="element-62" data-mp="1he2wzy8t5mf4">
      <div className="mx-auto max-w-3xl px-4" data-id="element-63" data-mp="1cfjcm29v4iov">
        <h2 id="faq-title" className="text-balance text-center text-3xl font-extrabold text-white md:text-4xl" data-id="element-64" data-mp="1ccndwbq6xpzd">
          Frequently asked questions
        </h2>
        <div className="mt-10 space-y-3" data-id="element-65" data-mp="254guw5e2qfhm">
          {questions.map(([question, answer], index) => {
          const isOpen = index === open;
          return <article key={question} className="overflow-hidden rounded-lg border border-slate-300/20 bg-blue-900/50" data-id="element-66" data-mp="1v5hiqcu3o1pv" data-mpi={index}>
                <h3 data-id="element-67" data-mp="opyq59ei33au">
                  <button type="button" className="flex w-full items-center justify-between gap-5 px-5 py-5 text-left font-bold text-white focus:outline-none focus-visible:ring-4 focus-visible:ring-slate-300/60 sm:px-6" onClick={() => setOpen(isOpen ? -1 : index)} aria-expanded={isOpen} data-id="element-68" data-mp="oqgu6s7emltb">
                    <span data-id="element-69" data-mp="1aorau1o11qgh">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-slate-300 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-70" data-mp="1fond9wh2t9tx" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-71" data-mp="16ps6ai67jvpk">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-72" data-mp="s0vz0nbz6mq0">
                      <p className="border-t border-slate-300/20 px-5 py-4 leading-relaxed text-slate-300 sm:px-6" data-id="element-73" data-mp="n22jkpd4oln7">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </article>;
        })}
        </div>
      </div>
    </section>;
}